var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_c('template',{slot:"content"},[_c('help-content',{attrs:{"title":'WeRUNアプリが使えない機種はありますか？'}},[_c('template',{slot:"content"},[_c('div',{staticClass:"text"},[_vm._v("ほとんどのスマホは問題なくご利用いただけます。動作確認済みの機種は以下の通りです。"),_c('br'),_vm._v("・iOS8以上（iPhone5S以後の機種）"),_c('br'),_vm._v("・Android6以上"),_c('br'),_vm._v("※サポート対象外機種：Xperia SO-04H")])])],2)],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c4ba760c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Help1.vue
// module id = InFu
// module chunks = 0